import { useEffect } from 'react';

import { AdButlerEvent, userEventViewableAd } from '@api';

import { useUserAdSettings } from '@store:web/utils/hooks/useUserAdSettings';

const handleViewable = async (event: { type: string; detail: AdButlerEvent }) => {
  try {
    await userEventViewableAd({ json: { rawData: event.detail, eventType: 'impression' } });
  } catch (error) {
    console.error(error);
  }
};

const useAdButlerHandler = () => {
  const { enabled } = useUserAdSettings();
  const AdButler = window?.AdButler;

  useEffect(() => {
    if (!AdButler || !enabled) {
      return;
    }

    AdButler.addEventListener(AdButler.EVENTS.VIEWABLE, handleViewable);
  }, [enabled]);
};

export default useAdButlerHandler;
